import React from 'react'

import { IconProps } from '../Types'

export const FireOutline = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps = {}) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="FireOutline"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path d="m16.5,14.77c0-.55-.45-1-1.01-1s-1.01.45-1.01,1c0,.47-.19.92-.52,1.25-.33.33-.79.52-1.26.52-.56,0-1.01.45-1.01,1s.45,1,1.01,1c1.01,0,1.98-.4,2.69-1.1.71-.71,1.11-1.66,1.11-2.66Z"/><path fill-rule="evenodd" d="m10.53,2c-.28,0-.56.08-.8.22-.04.02-.07.05-.11.07-.26.21-.44.5-.5.83-.06.32,0,.65.17.93.78,1.34,1.24,2.9,1.25,4.35,0,1.07-.23,2.04-.73,2.82-.45-.5-.81-1.07-1.09-1.69-.11-.26-.33-.45-.6-.54-.27-.09-.56-.06-.81.07-1.03.57-1.88,1.4-2.47,2.41-.58,1.01-.88,2.16-.85,3.32h0c.04,1.01.28,1.99.71,2.9.43.9,1.04,1.71,1.79,2.38.75.67,1.63,1.18,2.58,1.51.94.32,1.94.46,2.94.4,2.45,0,4.42-.77,5.79-2.1,1.38-1.33,2.08-3.14,2.17-5.07.2-4.59-3.04-10.02-8.72-12.63-.23-.12-.48-.19-.74-.19Zm2.04,6.39c0-1.21-.26-2.46-.71-3.62,4.1,2.49,6.25,6.65,6.11,9.96-.07,1.52-.61,2.81-1.56,3.73-.94.91-2.38,1.53-4.41,1.53-.02,0-.04,0-.07,0-.74.05-1.48-.05-2.18-.29-.7-.24-1.34-.62-1.89-1.11-.55-.49-1-1.08-1.31-1.75-.31-.66-.49-1.38-.52-2.1-.02-.8.18-1.58.58-2.27.23-.39.51-.75.85-1.05.48.77,1.09,1.46,1.8,2.05.39.33.98.31,1.35-.04,1.43-1.34,1.98-3.19,1.97-5.03Z"/>',
    }}
  />
)

FireOutline.displayName = 'FireOutline'

export const tags = ['FireOutline', '']
